<template>
  <div class="ceping75bd">
    <div class="men_detail">
      <img src="@a/cp55_top.png" alt="" />
    </div>
    <div class="ceping75-report" v-if="body_show">
      <div class="men_main">
        <h2 class=" cle clearfix"><span class="pull-left"></span><span class="pull-right"></span></h2>
        <h2>您已完成测评</h2>
        <div class="btn-g">
          <a class="close-btn" @click="checkPdfReport()">查看报告</a>
          <a class="reset-btn" @click="reset()">重测</a>
        </div>
      </div>
    </div>
    <!-- 发送邮箱 -->
    <van-popup v-model="fill_emails">
      <div class="confirm_box">
        <van-cell-group class="grouping">
          <van-field placeholder="请填写你的邮箱账号" v-model="mailbox" />
        </van-cell-group>
        <a class="cancel" href="javascript:;" @click="send_emails">发送报告到邮箱</a>
      </div>
    </van-popup>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 发送邮箱 -->
    <van-popup v-model="fill_emails">
      <div class="confirm_box">
        <van-cell-group class="grouping">
          <van-field placeholder="请填写你的邮箱账号" v-model="mailbox" />
        </van-cell-group>
        <a class="cancel" href="javascript:;" @click="send_emails">确认</a>
      </div>
    </van-popup>
    <!--  -->
    <div v-show="pdfBool">
      <div id="pdf"></div>
    <!-- pdf close -->
    <a class="pdf-close" @click="pdfBool=false">关闭</a>
    </div>
  </div>
</template>
<script>
import { ceping75_report, ceping75_reset, sendPdf} from "@/api/measurement";
import { shareCon} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { Dialog} from 'vant';
import { getLevel} from "@/api/course"
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        // 关卡
        next:{},
        // 邮箱
        mailbox:'',
        fill_emails: false,
        pdfh5: null,
        pdfBool:false
      }
    },
    mounted() {
      
    },
    methods: {
      // 查看报告
      checkPdfReport(){
        //调用加载中
        this.$emit('loadingHandle',true,"加载中..");
        if(this.pdfh5){
          this.pdfBool = true;
          //关闭加载中
          this.$emit('loadingHandle',false);
        }else{
          let self = this;
          //实例化
          this.pdfh5 = new Pdfh5("#pdf", {
            pdfurl: this.data.pdf_link
          });
          //监听完成事件
          this.pdfh5.on("complete", (status, msg, time)=> {
            console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒")
            if(status=='error'){
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast('报告预览失败！');
              return
            }
            this.pdfBool = true;
            //关闭加载中
            this.$emit('loadingHandle',false);
          })
        }
        
        // window.open(this.data.pdf_link);
      },
      send_emails() {
        if (this.$Validator.isEmail(this.mailbox)) {
          //调用加载中
          this.$emit('loadingHandle',true,"发送中");
          let q = this.$route.query;
           let ev_obj= {
            cid: this.data.cid,
            touser: this.mailbox
          };
          if(q.evaluation_id || q.evaluation_id==0){
            ev_obj['evaluation_id'] = q.evaluation_id;
          }
          sendPdf(ev_obj).then((data) => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast(data.msg);
              setTimeout(() => {
                this.fill_emails = false
                
              }, 200)
            }).catch(() => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast('报告发送可能有几分钟的延迟，请耐心等待。');
              setTimeout(() => {
                this.fill_emails = false
              }, 200)
            });
        } else {
          this.$toast('邮箱填写不正确！');
        }

      },
      /*
       *@param: 
       *@return: 
       *@Description: 开启下一个任务  1测评2音频3任务4小组讨论5案例
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-05 15:58:09
      */
      list_link() {
        let item = this.next;
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid +'&level_list_id=' + item.id+ '&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          this.$router.push(item.link + '?cid=' + item.cid +'&level_list_id=' + item.id+ '&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id + '&level_list_id=' + item.id+'&cid=' + item.cid)
        }
      },
    
      reset() {
        Dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping75_reset()
            .then((data) => {
              this.$router.push("/ceping75")
            })
        }).catch(() => {
          // on cancel
        });
      },

      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        if(q.level_list_id){
          getLevel({
            level_list_id:this.level_list_id
          }).then((data)=>{
            this.next = data.next;
          });
        }
        let ev_obj= {};
        if(q.evaluation_id || q.evaluation_id==0){
          ev_obj['evaluation_id'] = q.evaluation_id;
        }
        ceping75_report(ev_obj)
          .then((data) => {
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              
              this.data = data;
              this.qrcode = data.qrcode;

            
              if (this.data.need_subscribe && !this.data.subscribe) {
                this.isShow = true;
              };
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping75", this, this.type_obj);
            } else {
              let redirect_query = deepCopy(this.$route.query);
              if(redirect_query.evaluation_id) {
                delete redirect_query.evaluation_id;
              }
              this.$router.push({
                path:'/ceping75',
                query: redirect_query
              });
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
#pdf{
  position: fixed;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index:223;
}
.pdfjs .pdfViewer{
  padding:0;
}
.pdf-close{
  display:block;
  position: fixed;
  top:30px;
  right: 30px;
  width: 70px;
  height:70px;
  text-align:center;
  line-height:70px;
  border-radius:50%;
  z-index:224;
  color:#f1f1f1;
  font-size:20px;
  background-color: rgba(0, 0, 0, 0.4);
}
.ceping75bd{
  display: flex;
  flex-direction: column;
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}
.ceping75-report{
  display: flex;
  flex-direction: column;
  background-color: #fde784;
  flex: 1;
  .men_main {
    width: 690px;
    height: auto;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 30px;
    margin: 0 auto;
    margin-top: -132px;
    position: relative;
    h2.cle {
      width: 100%;
      margin-bottom: 150px;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: rgba(132, 73, 85, 1);
        border-radius: 10px;
      }
    }
  }
  h2{
    font-size: 44px;
    color: #333333;
    font-weight: bold;
    text-align: center;
  }
  .btn-g{
    margin: 400px auto 50px;
    display: flex;
    flex-direction: column;
    width: 100%;
    a.close-btn{
      display: block;
      width: 100%;
      line-height: 88px;
      background-color: #f1f1f1;
      color: #844955;
      text-align: center;
      font-size: 32px;
      letter-spacing: 2px;
    }
    a.reset-btn{
      display: block;
      width: 100%;
      line-height: 88px;
      background-color: #844955;
      color: #f1f1f1;
      text-align: center;
      font-size: 32px;
      margin-top: 50px;
      letter-spacing: 2px;
    }
  }

}


.mt34 {
  margin-top: 34px;
}

.title-2 {
  color: #222;
  font-weight: bold;
}

.bold-yellow {
  color: #F57F17;
  text-decoration: underline;
}

.show-img {
  margin-top: 51px;
  img {
    max-width: 100%;
  }
}


.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}




.confirm_box {
  padding: 50px 40px;
  border-radius: 12px;
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box a.cancel {
  color: #fff;
  background-color: #EB5032;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 8px
}

.grouping .van-cell .van-cell__value input {
  border: 2px solid #ccc;
  border-radius: 12px;
  font-size: 26px;
  color: #333;
}
// 关卡信息
.levelbtn-group{
  display: flex;
  line-height: 98px;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 50%;
  max-width: 750px;
  transform: translateX(-50%);
  z-index: 998;
  background-color: #EB5032;
  a{
    flex: 1;
    display: block;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
    &:nth-child(1){
      border-right: 1px solid #ffffff;
    }
    &:last-child{
      border-left: 1px solid #ffffff;
    }
  }
}
</style>
